import { Component, OnInit, AfterViewInit } from '@angular/core';

declare const lucide: any;

@Component({
  selector: 'app-custom-software-development',
  templateUrl: './custom-software-development.component.html',
  styleUrls: ['./custom-software-development.component.css']
})
export class CustomSoftwareDevelopmentComponent implements OnInit, AfterViewInit {
  
  // Popup state
  showDemoPopup = false;

  // Challenges data
  challenges = [
    {
      icon: 'zap',
      title: 'Increase Efficiency and Productivity',
      description: 'Streamline workflows and boost performance with enterprise-grade software tailored to specific business processes.'
    },
    {
      icon: 'shield-check',
      title: 'Minimize Bugs and Human Errors',
      description: 'Ensure accuracy and reliability through automation and AI-powered testing that reduce manual intervention.'
    },
    {
      icon: 'check-circle',
      title: 'Meet Regulatory Requirements',
      description: 'Embed compliance, auditability, and transparency into custom solutions, ensuring alignment with global standards.'
    }
  ];

  // Development services data
  developmentServices = [
    {
      icon: 'refresh-cw',
      title: 'Digital Transformation',
      description: 'Build, re-engineer, or modernize applications to meet evolving market requirements and customer expectations.'
    },
    {
      icon: 'settings',
      title: 'Product Customization',
      description: 'Adapt, refine, and extend existing solutions to fit enterprise ecosystems and unique workflows.'
    },
    {
      icon: 'trending-up',
      title: 'Legacy Modernization',
      description: 'Upgrade outdated systems into cloud-ready, mobile-first platforms.'
    },
    {
      icon: 'headphones',
      title: 'Ongoing Maintenance & Support',
      description: 'Continuous monitoring, optimization, and feature enhancements for sustained business value.'
    }
  ];

  // Service offerings data
  serviceOfferings = [
    {
      icon: 'palette',
      title: 'Solution Design & Engineering',
      description: 'User-friendly, secure, high-performance applications.'
    },
    {
      icon: 'plug',
      title: 'Integration Services',
      description: 'Seamless connection with ERP, CRM, analytics, and enterprise platforms.'
    },
    {
      icon: 'bot',
      title: 'Workflow Automation',
      description: 'AI-powered tools and RPA for faster, smarter processes.'
    },
    {
      icon: 'smartphone',
      title: 'Mobile-First Development',
      description: 'Real-time access across devices for modern workforces.'
    },
    {
      icon: 'cloud',
      title: 'DevOps & Cloud Enablement',
      description: 'Streamlined delivery pipelines and scalable deployments.'
    }
  ];

  // Partnership benefits data
  partnershipBenefits = [
    {
      icon: 'zap',
      title: 'Agility',
      description: 'Rapid response to market and customer needs with flexible development approaches.'
    },
    {
      icon: 'dollar-sign',
      title: 'Cost Efficiency',
      description: 'Lower long-term costs with optimized processes and scalable design architecture.'
    },
    {
      icon: 'lightbulb',
      title: 'Innovation Enablement',
      description: 'Accelerated adoption of AI, IoT, and next-generation technologies.'
    },
    {
      icon: 'shield',
      title: 'Security & Compliance',
      description: 'Robust protection aligned with industry regulations and best practices.'
    },
    {
      icon: 'rocket',
      title: 'Future-Proofing',
      description: 'Architecture built to evolve with business demands and technological advances.'
    }
  ];

  // Success results data
  successResults = [
    {
      number: '100%',
      title: 'Enterprise Analytics Platform',
      description: 'Delivered real-time decision intelligence for a global manufacturer.'
    },
    {
      number: 'IoT',
      title: 'IoT-Enabled Workforce App',
      description: 'Transformed field operations with mobile-first access and predictive analytics.'
    },
    {
      number: '40%',
      title: 'AI-Powered Automation',
      description: 'Reduced manual errors by 40% in a financial services platform.'
    },
    {
      number: 'Cloud',
      title: 'Cloud Migration & Modernization',
      description: 'Enhanced scalability and reduced infrastructure costs for a large logistics provider.'
    }
  ];

  // Journey data
  journey = [
    { step: '1', title: 'Expert Technology Advice', text: 'Evaluate opportunities, define strategies, and align with business goals.' },
    { step: '2', title: 'End-to-End Development', text: 'Move from ideation to deployment with mature, SDLC-driven processes.' },
    { step: '3', title: 'Forward-Looking Modernization', text: 'Enhance user experiences, optimize solutions, and embrace DevOps and cloud practices for continuous improvement.' }
  ];

  // Why choose EPPS data
  whyChoose = [
    {
      icon: 'award',
      title: 'Proven Track Record',
      description: 'Extensive experience in custom software engineering for enterprises across industries.'
    },
    {
      icon: 'graduation-cap',
      title: 'Technical Expertise',
      description: 'Strong expertise across cloud, open-source, and AI-driven technologies.'
    },
    {
      icon: 'headphones',
      title: 'End-to-End Support',
      description: 'Comprehensive support from consulting to long-term maintenance and optimization.'
    },
    {
      icon: 'target',
      title: 'Security Focus',
      description: 'Commitment to secure, scalable, and industry-compliant solutions.'
    }
  ];

  constructor() { }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    // Initialize Lucide icons
    if (typeof lucide !== 'undefined') {
      lucide.createIcons();
    }
  }

  // Popup methods
  openDemoPopup(): void {
    this.showDemoPopup = true;
    // Prevent body scroll when modal is open
    document.body.style.overflow = 'hidden';
  }

  closeDemoPopup(): void {
    this.showDemoPopup = false;
    // Restore body scroll when modal is closed
    document.body.style.overflow = 'auto';
  }

  onDemoFormSubmitted(success: boolean): void {
    if (success) {
      // Close popup after successful form submission
      setTimeout(() => {
        this.closeDemoPopup();
      }, 2000);
    }
  }

}
